import { HatElement } from '@/components/hat-element.js';

class HatPhotoGallery extends HatElement {
  private _photos: any[] = [];

  set photos(val: any[]) {
    this._photos = val;
    this.render();
  }

  render() {
    this.root.innerHTML = `
      <div class="gallery">
        ${this._photos.map(p => `
          <img src="${p.url}" />
        `).join('')}
      </div>
    `;
    this._applyEntitlements();
  }
}
customElements.define('hat-photo-gallery', HatPhotoGallery);